

// GET Action
export class getPolicy {
    static readonly type = '[Policy] Get';
}